import type { TFunction } from "i18next";

/**
 * Nome de cada domínio do modelo de carga, na ordem do backend (`DOMAIN_ORDER`).
 *
 * Cada rótulo é uma chamada de `t` com o texto literal, para a trava de i18n achar a chave;
 * domínio novo no backend aparece pelo nome técnico até ganhar o seu aqui.
 */
export function domainLabel(t: TFunction, name: string): string {
  switch (name) {
    case "source_system":
      return t("Source system");
    case "org_structure":
      return t("Organizational structure");
    case "users_and_roles":
      return t("Users and roles");
    case "system_usage":
      return t("System usage");
    case "chart_of_accounts":
      return t("Chart of accounts");
    case "custom_code":
      return t("Custom code");
    case "configuration":
      return t("Configuration");
    case "documents_and_volumes":
      return t("Documents and volumes");
    case "integrations":
      return t("Integrations");
    case "adherence_signals":
      return t("Adherence signals");
    default:
      return name;
  }
}
